import styles from "./borrowingCapacityResultPay.module.css";
import GetMonthlyPayment from "../../../helpers/monthlyPayment";

const BorrowingCapacityResultPay = ({ loan, rate, year }) => {
  let payment = GetMonthlyPayment(loan, rate, year);

  const USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  return (
    <>
      <label className={`form-label ${styles.label}`}>Monthly Repayment</label>
      <div className={styles.payment}>{USDollar.format(payment)}</div>
    </>
  );
};

export default BorrowingCapacityResultPay;
